<template>
<div>
    <div class="container">
        <el-page-header class="page-header" @back="goBack" content="信息确认"></el-page-header>
        <AreaHeader class="area-header-one" title="基本信息"></AreaHeader>
        <ul class="basic-info" v-if="consultInfo">
            <li><b>姓名：</b>{{consultInfo.name}}</li>
            <li><b>性别：</b>{{consultInfo.sex == '1'?'男':'女'}}</li>
            <li><b>电话：</b>{{consultInfo.phoneNo}}</li>
            <li><b>出生日期：</b>{{consultInfo.birthday}}</li>
            <li><b>常住地址：</b>{{consultInfo.liveArea}}</li>
            <li><b>出生地址：</b>{{consultInfo.birthArea}}</li>
        </ul>
        <AreaHeader class="area-header" title="处方使用信息"></AreaHeader>
        <ul class="basic-info" v-if="consultInfo.useDate">
            <li><b>开始服药时间：</b>{{consultInfo.useDate}}</li>
            <li><b>服药天数：</b>{{consultInfo.useDays}}</li>
        </ul>
        <AreaHeader class="area-header" title="症状信息"></AreaHeader>
        <table border="1" class="basic-info basic-table">
            <tr class="table-rows" v-for="(item,index) in basicTableArray" :key="item.key">
                <td v-if="index == 0" :rowspan="basicTableArray.length">基本情况</td>
                <td>{{item.key}}</td>
                <td>{{item.value}}</td>
            </tr>
            <tr class="table-rows" v-for="(item1,index) in shangjiaoTableArray" :key="item1.key" v-if="shangjiaoTableArray.length>0">
                <td v-if="index == 0" :rowspan="shangjiaoTableArray.length">上焦</td>
                <td>{{item1.key}}</td>
                <td>{{item1.value.toString()}}</td>
            </tr>
            <tr class="table-rows" v-for="(item2,index) in zhongjiaoTableArray" :key="item2.key" v-if="zhongjiaoTableArray.length>0">
                <td v-if="index == 0" :rowspan="zhongjiaoTableArray.length">中焦</td>
                <td>{{item2.key}}</td>
                <td>{{item2.value.toString()}}</td>
            </tr>
            <tr class="table-rows" v-for="(item3,index) in xiajiaoTableArray" :key="item3.key" v-if="xiajiaoTableArray.length>0">
                <td v-if="index == 0" :rowspan="xiajiaoTableArray.length">下焦</td>
                <td>{{item3.key}}</td>
                <td>{{item3.value.toString()}}</td>
            </tr>
        </table>
        <AreaHeader class="area-header" title="支付信息"></AreaHeader>
        <el-form class="basic-info form"  label-width="120px" label-position="right" >
            <div class="div-row">
                <span class="pay-text">支付金额：</span>
                <span class="pay-amount">{{payType.value == '公共账户'&&freeFlag=='Y'?0:price}}</span>
            </div>
            <WJTRadio
                v-model="payType.value"
                :label="payType.key+'：'"
                :must='payType.must'
                :radios='payType.options'>
            </WJTRadio>
        </el-form>
        <el-button class="btn-confirm" type="primary" @click="pay(false)" :loading="payLoading">确认支付</el-button>
        <el-button class="btn-back" type="primary" @click="goBack">返回修改</el-button>
    </div>
    <el-dialog title="微信支付" :visible.sync="qrcodeVisble" width="360px" :close-on-click-modal='dialogClosable'>
        <div class="dialog-wrapper">
            <div id="qrcode"></div>
            <span class="qrcode-dialog-text">二维码过期了？<b @click="qrcodeRefresh">立即刷新</b></span>
        </div>
    </el-dialog>

</div>
</template>

<script>
import AreaHeader from '@/components/widgets/area-header.vue'
import WJTRadio from '@/components/widgets/wjt-radio.vue'
import QRCode from 'qrcodejs2'
export default {
    components:{
        AreaHeader,
        WJTRadio,
        QRCode
    },
    data () {
        return{
            consultInfo:{},
            payType:{
                    key:'支付方式',
                    value:'公共账户',
                    options:[
                        '公共账户',
                        '微信支付'
                    ]
            },
            basicTableArray:[],
            shangjiaoTableArray:[],
            zhongjiaoTableArray:[],
            xiajiaoTableArray:[],
            submitData:{},
            price:0,
            freeFlag:false,
            visitRecordId:"",
            payLoading:false,
            qrcodeVisble:false,
            outTradeNo:'',
            dialogClosable:false
        }
    },
    created() {
      var userInfo = this.$store.getters.getUserInfo
      console.log("userInfo")
      console.log(userInfo)
      if(!this.utils.isEmptyObject(userInfo)){
        if(userInfo.doctor && userInfo.doctor.hospitalId != '101' && userInfo.doctor.status == '0'){
          this.payType.options = ['公共账户','微信支付']
          this.payType.value = '公共账户'
        }else{
          this.payType.value = '微信支付'
          this.payType.options = ['微信支付']
        }
      }
    },
    mounted(){
        this.initPageData()
        this.getPayAmount()
    },
    watch:{
        qrcodeVisble:function(val){
            if(!val&&this.mInterval != undefined && this.mInterval != null){
                clearInterval(this.mInterval)
            }
        }
    },
    methods:{
        goBack(){
            this.$router.go(-1)
        },
        pay(isRefresh){
            var params = {
                productId:this.visitRecordId,
                orderType:1,
                tradeType:'NATIVE',
                payChannel:this.payType.value=='微信支付'?'1':'3'
            }
            if(!isRefresh){
                this.payLoading = true
            }
            this.wjtHttp.post(this,'/api/api/pay/0.1/unifiedOrder',params,false,(res)=>{
                var data = res.data
                this.payLoading = false
                if(data.code == 200){
                    if(data.data.payChannel == 1 && !this.utils.isEmptyStr(data.data.qrcode)){
                      this.qrcodeVisble =  true
                      this.outTradeNo = data.data.outTradeNo
                      this.$nextTick(()=>{
                          if(this.mQrCode !=undefined && this.mQrCode !=null){
                              this.mQrCode.clear()
                              this.mQrCode.makeCode(data.data.qrcode)
                          }else{
                              this.mQrCode = new QRCode('qrcode', {
                                  text: data.data.qrcode,
                                  width: 256,
                                  height: 256,
                                  colorDark : "#000000",
                                  colorLight : "#ffffff",
                                  correctLevel : QRCode.CorrectLevel.H
                              });
                          }
                          this.getPayStatus();
                      })
                    }else{
                      this.$message({
                          message:"支付成功",
                          type:'success'
                      })
                      setTimeout(() => {
                          this.$router.push({
                              path:'/Prescription',
                              query:{
                                  visitRecordId:this.visitRecordId,
                                  patientId:this.consultInfo.patientId
                              }
                          })
                      }, 1000);
                    }
                }else{
                    this.$message({
                        message:!this.utils.isEmptyStr(data.msg)?data.msg:'支付异常，请联系管理员',
                        type:'error'
                    })
                }
            },(err)=>{
                console.log(err)
                this.payLoading = false
            })
        },
        qrcodeRefresh(){
            this.pay(true)
        },
        getPayStatus(){
            if(this.mInterval != undefined && this.mInterval != null){
                clearInterval(this.mInterval)
            }
            this.mInterval = setInterval(()=>{
                var params = {
                    outTradeNo:this.outTradeNo
                }
                this.wjtHttp.post(this,'/api/api/pay/0.1/query/place/result',params,false,(res)=>{
                var data = res.data
                if(data.code == 200){
                    if(data.data == 1103){
                         this.$message({
                            message:"支付成功",
                            type:'success'
                        })
                        this.qrcodeVisble = false
                        setTimeout(() => {
                            this.$router.replace({
                                path:'/Prescription',
                                query:{
                                    visitRecordId:this.visitRecordId,
                                    patientId:this.consultInfo.patientId,
                                    hasPaySuccess:'1'
                                }
                            })
                        }, 1000);
                        clearInterval(this.mInterval)
                    }
                }
            },(err)=>{
                console.log(err)
            })
            },3000)
        },
        //设置页面显示需要的数据格式
        initPageData(){
            var consult = JSON.parse(sessionStorage.getItem("consultInfo"))
            if(!this.utils.isEmptyObject(consult)){
                this.consultInfo = consult
            }
            console.log(this.consultInfo)
            this.basicTableArray.length = 0
            this.shangjiaoTableArray.length = 0
            this.zhongjiaoTableArray.length = 0
            this.xiajiaoTableArray.length = 0
            var submitData = JSON.parse(sessionStorage.getItem("submitData"))
            this.submitData = submitData
            var basicArray = submitData.basic_array
            if(!this.utils.isEmptyObject(basicArray)){
                for(var i=0;i<basicArray.length;i++){
                    if(i == 0){
                        this.basicTableArray.push(basicArray[i])
                    }else{
                        if(basicArray[i].value != '正常'){
                            this.basicTableArray.push(basicArray[i])
                        }
                    }
                }
            }
            var basicEnterArray = submitData.basic_enter_array
            if(!this.utils.isEmptyObject(basicEnterArray)){
                for(var i=0;i<basicEnterArray.length;i++){
                    if(basicEnterArray[i].value.length>0){
                        this.basicTableArray.push(basicEnterArray[i])
                    }
                }
            }
            var maixiangArray = submitData.maixiang_array
            if(!this.utils.isEmptyObject(maixiangArray)){
                for(var i=0;i<maixiangArray.length;i++){
                    if(maixiangArray[i].value != "正常"){
                        this.basicTableArray.push(maixiangArray[i])
                    }
                }
            }
            var shangjiaoArray = submitData.shangjiao_array
            if(!this.utils.isEmptyObject(shangjiaoArray)){
                for(var i=0;i<shangjiaoArray.length;i++){
                    if(shangjiaoArray[i].value.length>0){
                        this.shangjiaoTableArray.push(shangjiaoArray[i])
                    }
                }
            }
            var zhongjiaoArray = submitData.zhongjiao_array
            if(!this.utils.isEmptyObject(zhongjiaoArray)){
                for(var i=0;i<zhongjiaoArray.length;i++){
                    if(zhongjiaoArray[i].value.length>0){
                        this.zhongjiaoTableArray.push(zhongjiaoArray[i])
                    }
                }
            }
            var xiajiaoArray = submitData.xiajiao_array
            if(!this.utils.isEmptyObject(xiajiaoArray)){
                for(var i=0;i<xiajiaoArray.length;i++){
                    if(xiajiaoArray[i].value.length>0){
                        this.xiajiaoTableArray.push(xiajiaoArray[i])
                    }
                }
            }
        },
        //获取支付金额
        getPayAmount(){
            var newShangjiao_array = this.submitData.shangjiao_array.map((obj,index)=>{
                obj.value = this.submitData.shangjiao_array[index].value.toString()
                return obj
            })
            var newZhongjiao_array = this.submitData.zhongjiao_array.map((obj,index)=>{
                obj.value = this.submitData.zhongjiao_array[index].value.toString()
                return obj
            })
            var newXiajiao_array = this.submitData.xiajiao_array.map((obj,index)=>{
                obj.value = this.submitData.xiajiao_array[index].value.toString()
                return obj
            })
            var newSubmitData = {}
            newSubmitData.basic_array = this.submitData.basic_array
            newSubmitData.basic_enter_array = this.submitData.basic_enter_array
            newSubmitData.maixiang_array = this.submitData.maixiang_array
            newSubmitData.shangjiao_array = newShangjiao_array
            newSubmitData.zhongjiao_array = newZhongjiao_array
            newSubmitData.xiajiao_array = newXiajiao_array
            console.log(this.consultInfo)
            console.log(newSubmitData)
            var params = {
                patientId:this.consultInfo.patientId,
                toDoDay:this.consultInfo.useDate,
                takeDays:this.consultInfo.useDays,
                inquiryInfo:newSubmitData,
                visitRecordId:sessionStorage.getItem("visitRecordId")
            }
            this.wjtHttp.post(this,'/api/health/v1/price',params,false,(res)=>{
                var data = res.data
                if(data.code == 200){
                    this.price = data.data.price
                    this.freeFlag = data.data.freeFlag
                    this.visitRecordId = data.data.visitRecordId
                    sessionStorage.setItem("visitRecordId",this.visitRecordId)
                }else{
                    this.$message({
                        message:(data.msg&&data.msg.length > 0)?data.msg:'获取支付金额异常，请联系管理员',
                        type:'error'
                    })
                }
            },(err)=>{
                console.log(err)
            })
        }
    }
}
</script>

<style scoped>
.container{
    width: 1080px;
    margin: auto auto;
    display: flex;
    flex-direction: column;
}
.page-header{
    width: 1080px;
    margin-top: 30px;
    color: #333333;
    font-size: 20px;
}
.page-header >>> div{
    color:#333333;
    font-size: 20px;
}
.area-header-one{
    margin-top: 35px;
}
.basic-info{
    width: 985px;
    margin-top: 30px;
    margin-bottom: 30px;
}
.basic-table{
    margin-left: 35px;
}
  .table-rows>td{
      height: 50px;
      background: white;
      font-size: 18px;
  }
.basic-info>li{
    color: #333333;
    font-size: 18px;
    text-align: left;
    line-height: 40px;
}
.basic-info>li>b{
    font-weight: bold;
}
.div-row{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 985px;
}
.pay-text{
    font-size: 18px;
    color: #333333;
    line-height: 40px;
    margin-left: 18px;
}
.pay-amount{
    font-size: 18px;
    font-weight: bold;
    color: #156098;
    line-height: 40px;
    margin-left: 15px;
}
.btn-confirm{
    width: 384px;
    border-radius: 40px;
    margin-top: 60px;
    font-size: 18px;
    height: 45px;
    position: relative;
    left: calc(50% - 192px);
}
.btn-back{
    width: 384px;
    border-radius: 40px;
    margin-top: 20px;
    margin-bottom: 60px;
    font-size: 18px;
    height: 45px;
    background: #E8E8E8;
    border-width: 0px;
    color: #999999;
    position: relative;
    left: calc(50% - 203px);
}
.form{
    padding-left: 15px;
}
table{
    border-collapse: collapse;  /**设置小表格之间的间距为0*/
    border-right:1px solid #333333;
    border-top:1px solid #333333;
}
.basic-info>tr{
    height: 55px;
}
.dialog-wrapper{
    display: flex;
    flex-direction: column;
    align-items: center;
}
.qrcode-dialog-text{
    color: #333333;
    font-size: 20px;
    margin-top: 30px;
}
.qrcode-dialog-text>b{
    color:#156098;
    font-size: 20px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/kaifang/prescriptionResult.vue